import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { Menu } from 'src/app/core/models/menu';
import { SidebarService } from 'src/app/core/services/sidebar/sidebar.service';
import { ViewerService } from 'src/app/core/services/viewer/viewer.service';

@Component({
  selector: 'shared-sidebar-menu-item',
  templateUrl: './sidebar-menu-item.component.html'
})
export class SidebarMenuItemComponent {

  @Input('menu-item')
  public menuItem: Menu | undefined = undefined;

  constructor(
    private readonly _router: Router,
    private readonly _sidebarService: SidebarService,
    private readonly _viewerService: ViewerService
  ) { }

  public get url(): string {
    return this._router.url;
  }

  /**
   * Check property router of menuItem to assign if it could open the viewer.
   */
  public navigate(): void {
    if(this.menuItem?.route !== 'manual'){
      this._router.navigateByUrl(this.menuItem?.route!);
    } else {
      this._viewerService.viewManual();
    }
    this._sidebarService.toggleSidebar();
  }
}